import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Sugargoo Sheet
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Your trusted source for Sugargoo Spreadsheet resources, product finds, reviews, and shopping intelligence.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Home</Link></li>
              <li><a href="#categories" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Categories</a></li>
              <li><Link to="/article/sugargoo-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Spreadsheet Guide</Link></li>
              <li><Link to="/article/sugargoo-shipping-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Shopping Guide</Link></li>
              <li><Link to="/article/sugargoo-review" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Sugargoo Review</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">SEO Articles</h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/is-sugargoo-legit" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Is Sugargoo Legit?</Link></li>
              <li><Link to="/article/sugargoo-coupon-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Coupon Guide</Link></li>
              <li><Link to="/article/sugargoo-warehouse-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Warehouse Guide</Link></li>
              <li><Link to="/article/sugargoo-qc-photos-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">QC Photos Guide</Link></li>
              <li><Link to="/article/sugargoo-beginner-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">Beginner Guide</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Main Website</h4>
            <p className="text-sm text-foreground-500 leading-relaxed mb-3">
              Visit our main store for the latest Sugargoo spreadsheet products and exclusive deals.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Sugargoo Spreadsheet
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Sugargoo Sheet. All rights reserved. This is an independent educational resource.
          </p>
          <div className="flex flex-wrap items-center gap-4 md:gap-6">
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors">Home</Link>
            <Link to="/article/sugargoo-shipping-guide" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors">Shopping Guide</Link>
            <Link to="/article/sugargoo-spreadsheet-guide" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors">Articles</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors">Main Website</a>
          </div>
        </div>
      </div>
    </footer>
  );
}